import { Module, VuexModule, Action } from 'vuex-module-decorators';

import axios from 'axios';
import { toError, assertOk } from '@/services/normalize';
import { BASE_URL, FETCH_LOG_ACTIVITY_DETAIL, FETCH_LOG_ACTIVITY, FETCH_LOG_AGENT, M_POST } from '@/utils/api';
import type { ExtAxiosConfig } from '@/middleware/axios-ui';

import type { IfetchActivityLog } from '@/interface/Activity';

@Module({ name: 'activity' })
export default class Activity extends VuexModule {
  @Action
  async FetchActivityLogId(params: IfetchActivityLog) {
    try {
      const { data } = await axios({
        url: BASE_URL + FETCH_LOG_ACTIVITY_DETAIL,
        data: params,
        method: M_POST
      });

      assertOk(data, 'Fetch activity log failed');
      return data;
    } catch (err) {
      throw toError(err, 'Fetch activity log failed');
    }
  }

  @Action({ rawError: true })
  async FetchActivityLog(payload: any) {
    try {
      const { criteria, __successToast } = payload || {};

      const { data } = await axios({
        url: BASE_URL + FETCH_LOG_ACTIVITY,
        data: criteria,
        method: M_POST,
        __successToast
      } as ExtAxiosConfig);

      assertOk(data, 'Fetch activity log failed');
      return data;
    } catch (err) {
      throw toError(err, 'Fetch activity log failed');
    }
  }

  @Action({ rawError: true })
  async FetchActivityLogAgent(payload: any) {
    try {
      const { criteria, __successToast } = payload || {};

      const { data } = await axios({
        url: BASE_URL + FETCH_LOG_AGENT,
        data: criteria,
        method: M_POST,
        __successToast
      } as ExtAxiosConfig);

      assertOk(data, 'Fetch activity log agent failed');
      return data;
    } catch (err) {
      throw toError(err, 'Fetch activity log agent failed');
    }
  }
}
